<template lang="pug">
.mb-S
  .flex
    BriqInput.mb-S.search-input(
      v-if="!hideSearchInput"
      label="Search"
      v-model="query"
      hideOptionalMarker
      data-test-id="advanced-settings-search"
      )
    BriqToggleSwitch.mb-S.expand-panels-switch.text-center(
      v-if="!hideToggleAndKeepPanelsExpanded"
      label="Expand panels"
      v-model="expandPanels"
      )
  .expansion-panels
    AdvancedSettingsPanel(
      v-for="(group, groupName) in groupedSettings"
      :key="groupName"
      :group="group"
      :groupName="groupName"
      :expand="expandPanels"
      :disabled="disabled"
      :keepPanelExpanded="hideToggleAndKeepPanelsExpanded"
      )
</template>

<script>
import { filter, identity, reduce, pipe, props, map, toLower, includes, any } from 'ramda'
import AdvancedSettingsPanel from './AdvancedSettingsPanel.vue'

export default {
  name: 'AdvancedSettingsPanels',
  components: {
    AdvancedSettingsPanel,
  },
  props: {
    settings: { type: Array, required: true },
    disabled: Boolean,
    hideSearchInput: Boolean,
    hideToggleAndKeepPanelsExpanded: Boolean,
  },
  data() {
    return {
      query: '',
      expandPanels: false,
    }
  },
  computed: {
    groupedSettings() {
      const filterSettings = query =>
        query
          ? filter(
              pipe(
                props(['DisplayName', 'Group', 'Description']),
                map(toLower),
                any(includes(query)),
              ),
            )
          : identity
      const groupSettings = reduce((groups, setting) => {
        ;(groups[setting.Group] = groups[setting.Group] || []).push(setting)
        return groups
      }, {})
      return pipe(filterSettings(toLower(this.query)), groupSettings)(this.settings)
    },
    panel() {
      if (this.expandPanels) return [...Array(Object.keys(this.groupedSettings).length).keys()]
      else return []
    },
  },
  methods: {
    getComponent({ DataType, MaxOccurs }) {
      if (DataType === 'String' || DataType === 'Integer' || DataType === 'Decimal')
        return MaxOccurs !== 1 ? 'StandardInputMultiple' : 'StandardInput'
      return DataType
    },
    updateSetting(setting, newValue) {
      if (setting.DataType === 'MultiList') {
        setting.Values = (newValue && newValue.map(v => v.Value)) || []
      } else if (setting.MaxOccurs !== 1) {
        setting.Values = newValue || []
      } else {
        if (newValue === null) setting.Values = []
        else setting.Values[0] = newValue
      }
    },
    initExpandPanels() {
      if (this.hideToggleAndKeepPanelsExpanded) {
        this.expandPanels = true
        return
      }
      if (!this.$localStorage) return
      if (this.$localStorage.getItem('expandPanels') === null) {
        this.$localStorage.setItem('expandPanels', this.expandPanels)
      } else {
        this.expandPanels = JSON.parse(this.$localStorage.getItem('expandPanels'))
      }
    },
  },
  watch: {
    expandPanels: {
      handler: function(newval) {
        if (this.hideToggleAndKeepPanelsExpanded === false)
          this.$localStorage?.setItem('expandPanels', newval)
      },
    },
  },
  created() {
    this.initExpandPanels()
  },
}
</script>

<style lang="stylus">
.advanced-settings-panels .briq-form-element
  margin-bottom 24px

.search-input
  width 80%
  margin-right 20px

.expand-panels-switch
  width 20%

.briq-expansion-panel
  transition margin 0.3s ease-out

.briq-expansion-panel.expanded:not(:first-of-type), .briq-expansion-panel.expanded+.briq-expansion-panel
  margin-top 16px
</style>
